{
  "title": "Contabilitate",
  "exportCsv": "Exportă CSV",
  "addEntry": "Adaugă înregistrare",
  "close": "Închide",
  "uncategorized": "Necategorizat",
  "periods": {
    "month": "Luna aceasta",
    "last": "Luna trecută",
    "year": "Anul acesta",
    "all": "Tot timpul"
  },
  "cards": {
    "income": "Venituri",
    "expenses": "Cheltuieli",
    "net": "Net",
    "outstanding": "Restanțe",
    "indicative": "estimativ · la cursul curent"
  },
  "form": {
    "heading": "Înregistrare manuală",
    "type": "Tip",
    "expense": "Cheltuială",
    "income": "Venit",
    "amount": "Sumă",
    "rateOptional": "Curs către {primary} (opțional)",
    "date": "Dată",
    "category": "Categorie",
    "categoryNone": "(niciuna)",
    "description": "Descriere",
    "autoFetchHint": "Lasă cursul necompletat pentru a prelua automat cursul BCE pentru acea dată."
  },
  "fx": {
    "needsRateOne": "{n} înregistrare necesită un curs valutar",
    "needsRateMany": "{n} înregistrări necesită un curs valutar",
    "needsRateHelp": "Conversia automată către {primary} nu a fost disponibilă. Introdu cursul (1 unitate → {primary}) pentru a le include în totaluri.",
    "rateEquals": "1 {currency} =",
    "ratePlaceholder": "curs",
    "apply": "Aplică",
    "needsRateShort": "necesită curs"
  },
  "breakdown": {
    "incomeByCategory": "Venituri pe categorii",
    "expensesByCategory": "Cheltuieli pe categorii",
    "noIncome": "Niciun venit în această perioadă.",
    "noExpenses": "Nicio cheltuială în această perioadă.",
    "byCurrency": "Pe monedă (nativ)",
    "byCurrencyNote": "Totaluri în unitățile fiecărei monede, înainte de conversie."
  },
  "teacherPay": {
    "heading": "Plata profesorilor (această perioadă)",
    "boundedHint": "Alege o perioadă delimitată (nu „Tot timpul”) pentru a evalua salariile lunare.",
    "teacher": "Profesor",
    "basis": "Bază",
    "perClass": "Pe clasă",
    "monthly": "Lunar",
    "notSet": "nesetat",
    "sessions": "Sesiuni",
    "rate": "Tarif",
    "pay": "Plată",
    "inPrimary": "În {primary}",
    "needsRate": "necesită curs",
    "estimatedTotal": "Total estimat (estimativ, la cursul curent):",
    "export": "Exportă plata profesorilor"
  },
  "ledger": {
    "heading": "Înregistrări în registru",
    "date": "Dată",
    "type": "Tip",
    "category": "Categorie",
    "description": "Descriere",
    "amount": "Sumă",
    "inPrimary": "În {primary}",
    "studentPayment": "Plată elev",
    "needsRate": "necesită curs",
    "emptyHeading": "Nicio înregistrare încă",
    "emptyMessage": "Înregistrează o plată sau adaugă o înregistrare manuală pentru a popula registrul."
  },
  "toast": {
    "required": "Tipul, o sumă pozitivă, moneda și data sunt obligatorii",
    "entryAdded": "Înregistrare adăugată",
    "addFailed": "Adăugarea înregistrării a eșuat",
    "positiveRate": "Introdu un curs pozitiv",
    "rateApplied": "Curs aplicat"
  }
}
